module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/user-components/user-list/user-list.component.css
// module id = ./src/app/user-components/user-list/user-list.component.css
// module chunks = main